import { Grid, Skeleton } from "@mui/material";
import { TypographyH6 } from "@shared-ui-components/CustomTypography";
import { ErrorState, formatNumberWithCommaAndDollar } from "@src/constants";
import { FC } from "react";
import { ClosedOpenCheckWrapper } from "./style";

interface ClosedOpenCheckType {
  title: string;
  value: string | number | undefined;
  isLoading: boolean;
  isInteger?: boolean;
}

const ClosedOpenCheck: FC<ClosedOpenCheckType> = ({
  title,
  value,
  isLoading,
  isInteger,
}) => {
  const getValues = () => {
    if (!value) return <ErrorState />;
    return (
      <TypographyH6 className="amount">
        {isInteger
          ? formatNumberWithCommaAndDollar(value, 0, true)
          : formatNumberWithCommaAndDollar(value)}
      </TypographyH6>
    );
  };

  return (
    <Grid xs={6} md={6} item>
      <ClosedOpenCheckWrapper>
        <TypographyH6>{title}</TypographyH6>
        {isLoading ? <Skeleton width="70%" /> : getValues()}
      </ClosedOpenCheckWrapper>
    </Grid>
  );
};

ClosedOpenCheck.defaultProps = {
  isInteger: false,
};

export default ClosedOpenCheck;
